import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Skeleton from '@material-ui/lab/Skeleton';
import { propNumber, propBool } from '../../../../helpers/custom-prop-types';
const SlideSearchListInputCount = (props) => {
    const { count, loading } = props;
    if (loading) {
        return (_jsxs("div", Object.assign({ className: 'is_slide_view_count_box' }, { children: [_jsx(Skeleton, { className: 'is_slide_view_count_num is_loading', variant: 'rect' }), _jsx("span", Object.assign({ className: 'search_select_block_count_text' }, { children: "\u4EF6\u3092\u8868\u793A\u4E2D" }))] })));
    }
    if (count > 0) {
        return (_jsxs("div", Object.assign({ className: 'is_slide_view_count_box' }, { children: [_jsx("span", Object.assign({ className: 'is_slide_view_count_num' }, { children: count })), _jsx("span", Object.assign({ className: 'search_select_block_count_text' }, { children: "\u4EF6\u3092\u8868\u793A\u4E2D" }))] })));
    }
    return null;
};
SlideSearchListInputCount.propTypes = {
    count: propNumber().isRequired,
    loading: propBool().isRequired,
};
export default SlideSearchListInputCount;
